"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Favorites = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Favorites = function Favorites() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.6114 10.7675C3.63386 10.7857 3.65552 10.8048 3.67631 10.8249L10.0119 16.936L16.2534 10.9155C16.3011 10.8518 16.3563 10.7939 16.4178 10.7432C17.3777 9.95158 18 8.72515 18 7.33814C18 4.90989 16.1059 3 13.8405 3C12.6229 3 11.5214 3.54524 10.7543 4.42984C10.5644 4.64891 10.2887 4.77474 9.99872 4.77472C9.70877 4.77471 9.4331 4.64883 9.24318 4.42974C8.47636 3.54515 7.37522 3 6.15812 3C3.89371 3 2 4.90964 2 7.33814C2 8.7395 2.63508 9.97688 3.6114 10.7675ZM9.2744 3.08397C8.40868 2.40371 7.32895 2 6.15812 2C3.30937 2 1 4.38997 1 7.33814C1 9.04658 1.7755 10.5676 2.98207 11.5446L9.43606 17.7699C9.75406 18.0767 10.2696 18.0767 10.5876 17.7699L16.9597 11.6237C16.9951 11.5895 17.0266 11.553 17.0541 11.5147C18.24 10.5366 19 9.0292 19 7.33814C19 4.38997 16.69 2 13.8405 2C12.6693 2 11.5892 2.40375 10.7233 3.08406C10.461 3.29009 10.2184 3.52149 9.99879 3.77473C9.77924 3.52146 9.53664 3.29003 9.2744 3.08397Z",
      fill: "#383745"
    })
  });
};
exports.Favorites = Favorites;